import React from "react";
import { Box, Heading, Text, VStack, List, ListItem, Divider, Link as ChakraLink } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const requirements = [
  "You must have a current loan in good standing or a previous loan (paid-off not more than 3 months ago) to participate in the referral program.",
  "Your referral must be a new customer who is approved for and receives a loan of at least $2,500. For privacy reasons, we cannot disclose whether a referred applicant is approved or declined.",
  "You and your referred friend will each receive $100 referral cash after the referred loan has been active for 90 days and remains in good standing.",
  "All referral cash rewards are paid by EFT.",
];

const faqs = [
  {
    q: "What if I don’t have a Swift Credit loan account?",
    a: "Only current Swift Credit customers can participate in the referral program.",
  },
  {
    q: "Does the person I refer have to be a new customer?",
    a: "Yes. Referred customers must be new to Swift Credit and must not have had a loan with us previously.",
  },
  {
    q: "Do I get a credit each time the person I referred takes out a loan?",
    a: "No. Referral cash applies to the referred customer’s first qualifying loan only.",
  },
  {
    q: "Is there a limit to the number of people I can refer?",
    a: "No. You can refer as many new customers as you like. For each qualifying referral, both you and your friend receive $100 each.",
  },
  {
    q: "How long does it take to receive my referral cash?",
    a: "We send referral cash by EFT to your bank account on file once all requirements have been verified.",
  },
  {
    q: "If multiple people refer the same person, will everyone receive a credit?",
    a: "No. Only the first valid referral submitted for that person is eligible for referral cash.",
  },
  {
    q: "How can I tell whether my referral was approved for a loan?",
    a: "Loan approval details are confidential. If your referral receives a qualifying loan and remains in good standing for 90 days, your EFT referral cash will be processed.",
  },
];

export default function ReferralTermsConditions() {
  return (
    <Box maxW="1000px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 24, md: 32 }}>
      <VStack spacing={7} align="start">
        <Heading as="h1" size="xl">Referral Terms and Conditions</Heading>
        <Text color="gray.600">Effective Date: March 2, 2026</Text>

        <Text>
          These are the basic requirements of our referral program. Please read them carefully to confirm
          your eligibility to receive referral cash from Swift Credit.
        </Text>

        <Heading as="h2" size="md">Program Requirements</Heading>
        <List pl={6} styleType="disc" spacing={2}>
          {requirements.map((item) => (
            <ListItem key={item}>{item}</ListItem>
          ))}
        </List>

        <Heading as="h2" size="md">Frequently Asked Questions</Heading>
        <VStack align="start" spacing={4} w="100%">
          {faqs.map((item) => (
            <Box key={item.q}>
              <Text fontWeight="700">Q: {item.q}</Text>
              <Text mt={1}>A: {item.a}</Text>
            </Box>
          ))}
        </VStack>

        <Text>
          Have a question that is not listed here? We are happy to help with any questions or concerns
          about our referral program or loan products.
        </Text>
        <ChakraLink as={RouterLink} to="/help" color="blue.600" fontWeight="semibold" _hover={{ textDecoration: "underline" }}>
          Contact us now
        </ChakraLink>

        <Divider my={4} />
      </VStack>
    </Box>
  );
}
